import { TimeOffsetRelation, TimeOffsetUnit } from 'constants/enums';

import { TimeOffsetConfig } from './TimeOffsetField';

const units = [
  {
    value: TimeOffsetUnit.MINUTES,
    label: 'minutes'
  },
  {
    value: TimeOffsetUnit.HOURS,
    label: 'hours'
  },
  {
    value: TimeOffsetUnit.DAYS,
    label: 'days'
  }
];

type PresetKeys = 'eventBegins' | 'eventEnds';

const TimeOffsetConfigPresets: Record<PresetKeys, TimeOffsetConfig> = {
  eventBegins: {
    units,
    relations: [
      {
        value: TimeOffsetRelation.BEFORE,
        label: 'before the event begins'
      },
      {
        value: TimeOffsetRelation.AFTER,
        label: 'after the event begins'
      }
    ]
  },
  eventEnds: {
    units,
    relations: [
      {
        value: TimeOffsetRelation.BEFORE,
        label: 'before the event ends'
      },
      {
        value: TimeOffsetRelation.AFTER,
        label: 'after the event ends'
      }
    ]
  }
};

export { TimeOffsetConfigPresets };
